function getDistance(event) {
  return event.target.pageXOffset !== undefined
    ? event.target.pageXOffset
    : event.target.scrollLeft;
}

function getCurrentIndex(threshold, distance) {
  return threshold > distance ? 1 : Math.ceil(distance / threshold);
}

export { getDistance, getCurrentIndex };
